import React, { FC } from "react";

import { LandingAnchors } from "containers/landing-anchors";

import styles from "./landing-navigation-menu.module.scss";

type Props = {
  basePath?: string;
  onLinkClick?: () => void;
};

export const LandingNavigationMenu: FC<React.PropsWithChildren<Props>> = ({
  basePath,
  onLinkClick,
}) => {
  const handleScrollClick = (event: MouseEvent, anchor: string) => {
    const element = document.getElementById(anchor);
    if (element) {
      event.preventDefault();
      onLinkClick?.();

      element.scrollIntoView({ behavior: "smooth" });

      if (window.history.pushState) {
        window.history.pushState(null, "", `#${anchor}`);
      } else {
        window.location.hash = `#${anchor}`;
      }
    }
  };

  return (
    <ul className={styles.root}>
      <li className={styles.item}>
        <a
          className={styles.link}
          href={`${basePath || ""}#${LandingAnchors.HOME}`}
          // @ts-ignore
          onClick={(event: MouseEvent) =>
            handleScrollClick(event, LandingAnchors.HOME)
          }
        >
          <span className={styles.linkText}>Home</span>
        </a>
      </li>
      <li className={styles.item}>
        <a
          className={styles.link}
          href={`${basePath || ""}#${LandingAnchors.PLANS}`}
          // @ts-ignore
          onClick={(event: MouseEvent) =>
            handleScrollClick(event, LandingAnchors.PLANS)
          }
        >
          <span className={styles.linkText}>Plans™</span>
        </a>
      </li>
      <li className={styles.item}>
        <a
          className={styles.link}
          href={`${basePath || ""}#${LandingAnchors.HOW_IT_WORKS}`}
          // @ts-ignore
          onClick={(event: MouseEvent) =>
            handleScrollClick(event, LandingAnchors.HOW_IT_WORKS)
          }
        >
          <span className={styles.linkText}>How it works</span>
        </a>
      </li>
    </ul>
  );
};
